var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 162,
    viewBox: "0 0 169 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.123 52.8612L100.268 39.6654L97.2285 44.9292L120.084 58.125L123.123 52.8612Z",
    fill: "#FF69F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.893 55.9403L95.877 47.2705L92.8379 52.5343L107.854 61.2041L110.893 55.9403Z",
    fill: "#FF69F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.133 59.868L91.4863 54.8759L88.4472 60.1398L97.0938 65.1319L100.133 59.868Z",
    fill: "#FF69F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.123 52.861L100.268 39.6652L97.2285 44.9291L120.084 58.1249L123.123 52.861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.893 55.9404L95.877 47.2706L92.8379 52.5344L107.854 61.2042L110.893 55.9404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.133 59.8674L91.4863 54.8753L88.4472 60.1391L97.0938 65.1312L100.133 59.8674Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9253 75.0406L17.7754 90.8886L25.5258 95.3633L34.6757 79.5153L26.9253 75.0406Z",
    fill: "#FF69F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9819 86.9474L28.9736 97.3539L36.7241 101.829L42.7323 91.4221L34.9819 86.9474Z",
    fill: "#FF69F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6256 97.8156L40.167 103.806L47.9174 108.281L51.376 102.29L43.6256 97.8156Z",
    fill: "#FF69F9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9262 75.0409L17.7764 90.889L25.5268 95.3637L34.6767 79.5157L26.9262 75.0409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9829 86.9477L28.9746 97.3543L36.725 101.829L42.7333 91.4224L34.9829 86.9477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6266 97.816L40.168 103.806L47.9184 108.281L51.377 102.291L43.6266 97.816Z",
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36507 101.448L103.218 155.634C104.446 156.346 105.802 156.808 107.209 156.995C108.616 157.182 110.046 157.09 111.417 156.724C112.788 156.358 114.074 155.725 115.2 154.862C116.326 153.998 117.271 152.921 117.981 151.692L162.635 74.349C163.344 73.1199 163.805 71.763 163.989 70.3558C164.174 68.9486 164.079 67.5189 163.711 66.1483C163.342 64.7778 162.707 63.4933 161.842 62.3685C160.976 61.2437 159.898 60.3005 158.667 59.5931L64.8143 5.40697C63.5862 4.69646 62.2301 4.23484 60.8235 4.04842C59.4169 3.86201 57.9874 3.95446 56.6165 4.32051C55.2457 4.68656 53.9604 5.31904 52.8339 6.18183C51.7075 7.04461 50.7621 8.12082 50.0516 9.34899L5.39759 86.692C4.68921 87.9214 4.22991 89.2783 4.04592 90.6852C3.86194 92.0921 3.95686 93.5214 4.32527 94.8916C4.69369 96.2618 5.32838 97.5461 6.19311 98.671C7.05784 99.7959 8.13567 100.74 9.36507 101.448Z",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.874 109.061L117.338 128.382",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8086 112.637L115.273 131.958",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7441 116.214L113.208 135.534",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6738 119.799L111.138 139.119",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6094 123.375L109.074 142.696",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1016 16.942L92.5657 36.2626",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0371 20.5188L90.5013 39.8393",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9717 24.0953L88.4358 43.4158",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9072 27.672L86.3714 46.9925",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8369 31.2562L84.3011 50.5767",
    stroke: "#EDF9FF",
    strokeWidth: 1.0631,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.603 95.7274L135.047 102.76L144.713 84.3578L123.919 85.1729L128.367 92.1976L118.3 98.5599C117.45 98.0736 116.463 97.8822 115.493 98.0155L109.313 89.2162C109.909 88.1842 110.07 86.9577 109.762 85.8066C109.454 84.6555 108.701 83.674 107.668 83.0782C106.636 82.4823 105.41 82.3209 104.259 82.6293C103.108 82.9377 102.126 83.6908 101.53 84.7229C101.208 85.2803 101.011 85.9013 100.953 86.5426L82.9583 92.1492C82.6713 91.8326 82.3385 91.5606 81.971 91.3423C81.7805 91.2409 81.5835 91.1524 81.3813 91.0772L77.0796 61.7793C77.6013 61.4042 78.0351 60.92 78.3509 60.3604C78.9468 59.3283 79.1083 58.1018 78.7998 56.9507C78.4914 55.7996 77.7383 54.8182 76.7062 54.2223C75.6742 53.6265 74.4477 53.465 73.2966 53.7734C72.1455 54.0819 71.164 54.8349 70.5682 55.867C70.3452 56.2726 70.1839 56.7091 70.0895 57.1622L41.2329 65.1742C40.8962 64.7714 40.4929 64.4294 40.0406 64.1628C39.272 63.7212 38.3897 63.5173 37.5053 63.5769C36.6208 63.6365 35.7739 63.9569 35.0714 64.4976C34.369 65.0384 33.8426 65.7752 33.5588 66.615C33.2749 67.4548 33.2463 68.3598 33.4766 69.2159C33.707 70.0719 34.1859 70.8404 34.8528 71.4244C35.5197 72.0083 36.3448 72.3815 37.2237 72.4968C38.1027 72.612 38.996 72.4642 39.791 72.0719C40.5859 71.6796 41.2468 71.0605 41.69 70.2928C41.8742 69.9701 42.0157 69.6248 42.1108 69.2656L71.242 61.1323C71.5351 61.4517 71.8732 61.7266 72.2455 61.9485C72.4841 62.0856 72.7343 62.2012 72.9932 62.2941L77.2375 91.5051C76.6205 91.9125 76.1135 92.4659 75.7615 93.1162C75.4096 93.7665 75.2236 94.4936 75.22 95.233C75.2164 95.9724 75.3953 96.7012 75.7409 97.3549C76.0865 98.0086 76.588 98.5669 77.201 98.9803C77.8141 99.3937 78.5197 99.6495 79.2552 99.7248C79.9908 99.8002 80.7336 99.6929 81.4177 99.4124C82.1019 99.132 82.7062 98.687 83.1772 98.117C83.6482 97.547 83.9712 96.8695 84.1177 96.1448L102.568 90.4026C102.762 90.5656 102.968 90.7134 103.184 90.8448C103.955 91.291 104.842 91.4956 105.73 91.4319L112.038 100.456C111.726 101.074 111.56 101.756 111.556 102.449C111.551 103.142 111.707 103.826 112.011 104.448C112.315 105.071 112.759 105.614 113.308 106.036C113.857 106.458 114.497 106.747 115.177 106.88C115.856 107.014 116.558 106.988 117.226 106.804C117.894 106.621 118.51 106.286 119.027 105.824C119.543 105.363 119.946 104.788 120.203 104.145C120.46 103.502 120.565 102.808 120.509 102.117L130.603 95.7274Z",
    fill: "#EDF9FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart4);
export default __webpack_public_path__ + "static/media/chart-4.e308489952628c126fe7a67bff8ae31c.svg";
export { ForwardRef as ReactComponent };